<template>
	<div class="bright">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row px-3 py-3" v-if="hasPageChild==0">

			<div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12 mb-3">
						<h4>CUSTOMER OVERVIEW</h4>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 mb-0">
						<h5><i class="el-icon-office-building"></i>&nbsp; JENIS PERUSAHAAN</h5><div v-if="false" class="widget-main-title">JENIS PERUSAHAAN</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-3 mb-4" v-for="item, index in overviewdata?.data?.company_type" :key="item">
						<div :class="'card-app ' + 'border-start-' + colortype[index % colortype.length]">
							<div class="card-body px-3 py-2">
								<div class="d-flex justify-content-between align-items-center mb-2">
									<div class="me-2">
										<div :class="'text-' + colortype[index % colortype.length] + ' widget-title-card'">{{ formatNum(item.Jumlah, 0) }}</div>
										<div class="card-text">{{ item.JenisPerusahaan }}</div>
									</div>
									<div :class="'d-flex icon-circle text-' + colortype[index % colortype.length] + ' text-center align-items-center justify-content-center widget-icon'" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-office-building"></i></div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<Loader v-if="loading.overview"/>
			</div>		

			<div class="col-md-12 mb-2">
				<div class="row">
					<div class="col-md-12 mb-0">
						<h5><i class="el-icon-sold-out"></i>&nbsp; JENIS LANGGANAN</h5><div v-if="false" class="widget-main-title">JENIS LANGGANAN</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-3 mb-3" v-for="item,index in overviewdata?.data?.subscribe_type" :key="item">
						<div :class="'card-app ' + 'border-start-' + colortype[index % colortype.length]">
							<div class="card-body px-3 py-2">
								<div class="d-flex justify-content-between align-items-center mb-2">
									<div class="me-2">
										<div :class="'text-' + colortype[index % colortype.length] + ' widget-title-card'">{{ formatNum(item.Jumlah, 0) }}</div>
										<div class="card-text">{{ item.JenisLangganan }}</div>
									</div>
									<div :class="'d-flex icon-circle text-' + colortype[index % colortype.length] + ' text-center align-items-center justify-content-center widget-icon'" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-sold-out"></i></div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<Loader v-if="loading.overview"/>
			</div>

			<div class="col-md-12 mb-3">
				<div class="row">
					<div class="col-md-12 mb-0">
						<h5><i class="el-icon-bank-card"></i>&nbsp; CARD STATUS</h5><div v-if="false" class="widget-main-title">CARD STATUS</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-3 mb-2">
						<div class="card-app border-start-primary">
							<div class="card-body px-3 py-2">
								<div class="d-flex justify-content-between align-items-center mb-2">
									<div class="me-2">
										<div class="text-primary widget-title-card">{{ formatNum(overviewdata?.data?.card_status[0]?.EnabledCard ?? 0, 0) }}</div>
										<div class="card-text">Enable Cards</div>
									</div>
									<div class="d-flex icon-circle text-primary text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-bank-card"></i></div>
								</div>
								<!--
								<div class="card-text">
									<div class="d-inline-flex align-items-center">
										<i class="material-icons icon-xs text-success">arrow_upward</i>
										<div class="caption text-success fw-500 me-2">3%</div>
										<div class="caption">from last month</div>
									</div>
								</div>
								-->
							</div>
						</div>
						
					</div>

					<div class="col-md-3 mb-2">
						<div class="card-app border-start-success">
							<div class="card-body px-3 py-2">
								<div class="d-flex justify-content-between align-items-center mb-2">
									<div class="me-2">
										<div class="text-success widget-title-card">{{ formatNum(overviewdata?.data?.card_status[0]?.DisabledCard ?? 0, 0) }}</div>
										<div class="card-text">Disable Cards</div>
									</div>
									<div class="d-flex icon-circle text-success text-center align-items-center justify-content-center widget-icon" style="border-radius: 50%; font-size: 40px;"><i class="el-icon-bank-card"></i></div>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				<Loader v-if="loading.overview"/>
			</div>

			<div class="col-md-12">
				
				<div class="row">
					<div class="col-md-6 mb-3">
						<el-card shadow="never" :body-style="{ paddingLeft: '12px', paddingRight: '12px', paddingTop: '0px', paddingBottom: '8px' }">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 TOPUP TERTINGGI YTD {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Customer Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in overviewdata?.data?.topup_teringgi_ytd" :key="'ytd_'+item.CustomerID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.CustomerName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>						
						</el-card>
						<Loader v-if="loading.overview"/>
					</div>

					<div class="col-md-6 mb-3">
						<el-card shadow="never" :body-style="{ paddingLeft: '12px', paddingRight: '12px', paddingTop: '0px', paddingBottom: '8px' }">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 TOPUP TERTINGGI {{ (getMonthName(month)).toUpperCase() }} {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Customer Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in overviewdata?.data?.topup_teringgi_month" :key="'month_'+item.CustomerID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.CustomerName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>						
						</el-card>
						<Loader v-if="loading.overview"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-3">
						<el-card shadow="never" :body-style="{ paddingLeft: '12px', paddingRight: '12px', paddingTop: '0px', paddingBottom: '8px' }">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 TRANSAKSI TERTINGGI YTD {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Pool Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in overviewdata?.data?.transaksi_tertinggi_ytd" :key="'ytd_'+item.ItemID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.PoolName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>						
						</el-card>
						<Loader v-if="loading.overview"/>
					</div>

					<div class="col-md-6 mb-3">
						<el-card shadow="never" :body-style="{ paddingLeft: '12px', paddingRight: '12px', paddingTop: '0px', paddingBottom: '8px' }">
							<div slot="header">
								<h5 class="text-center m-0 px-2">TOP 10 TRANSAKSI TERTINGGI {{ (getMonthName(month)).toUpperCase() }} {{ year }}</h5>
							</div>
							<div>
								<table class="table-g" style="width:100%;">
									<thead>
										<tr class="border-bottom">
											<th class="pb-2">Customer Id</th>
											<th class="pb-2 px-3">Pool Name</th>
											<th class="text-center">Total</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="item in overviewdata?.data?.transaksi_tertinggi_month" :key="'month_'+item.ItemID">
											<td class="py-2 align-top">{{ item.CustomerID }}</td>
											<td class="py-2 px-3">{{ item.PoolName }}</td>
											<td class="py-2 align-top text-right">{{ formatNum(item.Total, 0) }}</td>
										</tr>
										<!--
										<tr class="border-top">
											<td class="pt-2 fw-bold" colspan="2">Total</td>
											<td class="text-center font-weight-bold">{{ formatNum(totalPegawaiByJabatan, 0) }}</td>
										</tr>
										-->
									</tbody>
								</table>
							</div>						
						</el-card>
						<Loader v-if="loading.overview"/>
					</div>
				</div>
				
			</div>
			<div class="col-md-12 mb-0">
				<ListItem class=" mb-0" title="TOP 10 PIUTANG" :data="reportdata.data" itemcol="Name" valuecol="SumAmountInDC" 
					textvaluecol="SAM"
					url="/finance/report-group?tab=1"/>
			</div>
			<div v-if="false" class="col-md-12 mb-0 pl-0">
				<ListItemPiutangByAging class="mb-0" title="TOP 10 PIUTANG BY AGING" :data="reportdatapiutangbyaging.data" itemcol="Name" valuecol="SumAmountInDC" 
					textvaluecol="SAM"
					url="/finance/report-group?tab=1"/>
			</div>

			
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem2.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import ListItemPiutangByAging from '@/views/pages/ListItemPiutangByAging.vue'
import Customer from '@/components/page/Customer.js'
import Footer from '@/views/Footer.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Customer,
	components:{
		Footer,
		ListItem,
		ListItemPiutangByAging,    
		Loader,
	},
    mounted(){
		//this.loadTop();
		//this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
		//document.title=this.$store.state.page+' - Dashboard'
		this.getData();
		this.getDataTopPiutangByAging();
		this.getDataCustomerOverview();
    },
	data() {
		return {
			month: Penanggalan().bulan,
			year: Penanggalan().tahun,

			overviewdata: [],
			spbu:{ 
				data:{}, list:[], types:[] 
			},
			loading: {
				table: false,
				overview: false,
			},
			reportdata: [],
			reportdatapiutangbyaging: {
				data: [],
			},

			colortype: ["primary","success","warning","danger"],
		}
	},
	watch: {

	},
    methods:{
		getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopPiutangByAging() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/customer/top-piutang-by-aging?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatapiutangbyaging = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataCustomerOverview() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/customer/customeroverview?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.overview = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.overviewdata = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.overview = false;
			})     

        },
	},
}

</script>

<style>
.card {
	border-radius: 6px !important;
	box-shadow: 0 10px 17px 0 rgba(0, 0, 0, 0.04) !important;
}

.card-raised {
    border: none !important;
}

.border-green {
    border-color: #007BFF !important;
}

.widget-title-card {
	font-size: 25px;
}

.border-start-primary {
	border-left: 5px solid #007BFF !important; /** card-raised border-start border-green border-5 */
}

.border-start-success {
	border-left: 5px solid #67C23A !important; /** card-raised border-start border-green border-5 */
}

.border-start-warning {
	border-left: 5px solid #E6A23C !important; /** card-raised border-start border-green border-5 */
}

.border-start-danger {
	border-left: 5px solid #F56C6C !important; /** card-raised border-start border-green border-5 */
}

.widget-icon {
	opacity: .3;
}

.widget-main-title {
	background: #ecf5ff /*#409EFF*/;
	color: #409eff;
	font-size: 20px;
	border-radius: 6px;
	padding: 6px 12px;
	border: 0px solid #b3d8ff;
	font-weight: 600;

	/*-moz-background-clip: ;box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.03); */
}

.card-app {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.062);
    border-radius: 6px;
}


.table-g {
	width: 100%;
	border-collapse: collapse;
}

.table-g th {
	padding: 10px;
	text-align: left;
	border: 0px solid #ddd;
	background-color: #fff;
	color: #252f40;
	font-size: 16px;
}

.table-g td {
	padding: 10px;
	text-align: left;
	border: 0px solid #ddd;
	font-size: 14px;
}

/* Background untuk baris ganjil */
.table-g tr:nth-child(odd) {
	background-color: #FAFAFA;
}

/* Background untuk baris genap */
.table-g tr:nth-child(even) {
	background-color: #ffffff;
}

/* Efek hover */
.table-g tr:hover {
	background-color: #dcdcdc77;
}
</style>